import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import '@/registerServiceWorker'
import vuetify from '@/plugins/vuetify';

// --- vue-sweetalert2 임포트 및 전역 설정 ---
// --- 커스텀 SweetAlert2 헬퍼 플러그인 임포트 및 등록 ---
import harrisSwal from '@/harrisSwal.js'; // 커스텀 SweetAlert2 헬퍼 플러그인
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(harrisSwal); // Vue.use()를 사용하여 플러그인 등록
// ------------------------------------------

//taiwindcss
import '@/assets/tailwind'

//뷰파이어 노드 모듈 가져와서 Vue에 연결
import {rtdbPlugin} from 'vuefire'
Vue.use(rtdbPlugin);

// 클라우드 파이어스토어 모듈 가져옴
import { firestorePlugin } from 'vuefire'
// 클라우드 파이어스토어 모듈 사용 준비
Vue.use(firestorePlugin)

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
